import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 20px;
  h3 {
    font-size: 24px;
  }
`;

export const GoatPen = styled.div`
  position: relative;
  height: 340px;
  overflow: hidden;
  display: flex;
  justify-content: center;
`;

export const AnimationContainer = styled.div`
  position: absolute;
  height: 280px;
  width: 280px;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  pointer-events: none;

  & > * {
    height: 100%;
    width: 100%;
  }
`;

export const GoatFood = styled.div`
  position: relative;
  z-index: 1;
  color: #008080;
  font-size: 300px;
  line-height: 280px;
  font-weight: 600;
`;
